import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NavigationBar from './NavigationBar';

class LoginPage extends Component {
  constructor() {
    super();
    this.state = {date: null};
    this.logIn = this.logIn.bind(this);
  }

  componentDidMount() {
    fetch(`/api/userProfile`, { credentials: 'same-origin' }).then(response => {
      response.json().then(data => {
        if (data.userRole === 'ADMIN' || data.userRole === 'ROOT') {
          location.href = '#/admin';
        }
      });
    });
  }

  render() {

    const {date} = this.state;

    return (
      <div>
        <NavigationBar />
        <div className="container">
        <h1>Panel administracyjny</h1>
        { this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : '' }
        <form className="col-md-3">
          <div className="form-group">
            <input type="text" className="form-control" onChange={this.onLoginChanged()} placeholder="Login" />
          </div>
          <div className="form-group">
            <input type="password" className="form-control" onChange={this.onPasswordChanged()} placeholder="Hasło" />
          </div>
          <button className="btn btn-primary" onClick={this.logIn}>Zaloguj się</button>
        </form>
        </div>
      </div>
    );
  }

  logIn() {
    fetch(
      `/api/login`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          username: this.state.login,
          password: this.state.password
        })
      }).then(response => {
        if (response.status === 200) {
          window.localStorage.setItem("loggedAsAdmin", true);
          location.href = '#/admin';
        } else {
          this.setState({ error: 'Nieprawidłowa nazwa użytkownika i/lub hasło.' });
        }
      });
  }

  onLoginChanged() {
    return (evt) => {
      this.setState({ login: evt.target.value });
    };
  }

  onPasswordChanged() {
    return (evt) => {
      this.setState({ password: evt.target.value });
    };
  }
}

LoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {};
}

export default translate('translations')(connect(mapStateToProps)(LoginPage));



// WEBPACK FOOTER //
// ./components/LoginPage.js